import {
  type FilterValue,
  type NumberFilterDefinition,
} from '@factorialco/f0-react/dist/experimental'

export type NumberFilterValue = FilterValue<NumberFilterDefinition>

const identity = (value: number) => value
const toCents = (value: number) => value * 100

const mapNumberFilterToVariables = (
  numberFilterValue: NumberFilterValue,
  fieldName: string,
  transformValue: (value: number) => number = identity
) => {
  if (!numberFilterValue) return {}

  if (numberFilterValue.mode === 'single') {
    return numberFilterValue.value !== undefined
      ? {
          [`${fieldName}Gteq`]: transformValue(numberFilterValue.value),
          [`${fieldName}Lteq`]: transformValue(numberFilterValue.value),
        }
      : {}
  }

  if (numberFilterValue.mode === 'range') {
    return {
      ...(numberFilterValue.from.value !== undefined
        ? { [`${fieldName}Gteq`]: transformValue(numberFilterValue.from.value) }
        : {}),
      ...(numberFilterValue.to.value !== undefined
        ? { [`${fieldName}Lteq`]: transformValue(numberFilterValue.to.value) }
        : {}),
    }
  }

  return {}
}

export const mapWorkingTimeFilterToVariables = (numberFilterValue: NumberFilterValue) =>
  mapNumberFilterToVariables(numberFilterValue, 'workingTime')

export const mapSalaryFilterToVariables = (numberFilterValue: NumberFilterValue) =>
  mapNumberFilterToVariables(numberFilterValue, 'salary', toCents)

export const getNumberFilterUpperValue = (
  numberFilterValue: NumberFilterValue
): number | undefined => {
  if (!numberFilterValue) return undefined
  if (numberFilterValue.mode === 'single') return numberFilterValue.value
  if (numberFilterValue.mode === 'range') {
    return numberFilterValue.to.value ?? numberFilterValue.from.value
  }
  return undefined
}
